import { Card, CardContent, Divider, Grid, Typography } from '@mui/material'
import { GreenText, LabelField } from 'components'
import { ClusterShipperDto } from 'dtos/clusterShipperDto'
import { formatDate } from 'utils'

interface ClusterShippersDetailsCardProps {
  clusterShipper: ClusterShipperDto
}

export default function ClusterShippersDetailsCard({
  children,
  clusterShipper
}: React.PropsWithChildren<ClusterShippersDetailsCardProps>) {
  return (
    <>
      <Card>
        <CardContent>
          <Grid container spacing={2} alignItems='flex-start'>
            <Grid item xs={12} container alignContent='center' justifyContent='space-between'>
              <Grid item xs={12} sm='auto' container spacing={1}>
                <Grid item>
                  <Typography fontWeight='bold' variant='h5'>
                    Cluster Shipper #{clusterShipper.clusterShipperNumber}
                  </Typography>
                </Grid>
              </Grid>

              <Grid item xs={12} sm='auto'>
                {children}
              </Grid>
            </Grid>

            <Grid item xs={12}>
              <Divider />
            </Grid>

            <Grid item xs={6} md={3}>
              <LabelField label='Cluster Conversion Company' value={clusterShipper.clusterConversionCompany?.name} />
            </Grid>

            <Grid item xs={6} md={3}>
              <LabelField label='Exporter' value={clusterShipper.exporterCompany?.name} />
            </Grid>

            <Grid item xs={6} md={3}>
              <LabelField label='Buyer' value={clusterShipper.buyerCompany?.name} />
            </Grid>

            <Grid item xs={6} md={3}>
              <LabelField
                label='Drop Off Date'
                value={clusterShipper.dropOffDate ? formatDate(clusterShipper.dropOffDate) : ''}
              />
            </Grid>

            <Grid item xs={6} md={3}>
              <LabelField
                label='Cluster Conversions Completed'
                value={
                  clusterShipper.clusterConversionsCompletedDate
                    ? formatDate(clusterShipper.clusterConversionsCompletedDate)
                    : ''
                }
              />
            </Grid>

            <Grid item xs={12}>
              <GreenText variant='outlined'>
                {`**Cluster Shipper Number:**

Cluster Shipper # is a read-only label that’s value is auto populated on save when Adding a Cluster Shipper

**Generate Cluster Shippers Button:**

Clicking this button downloads the Cluster Shipper PDF to the user’s machine for printing.

The PDF reflects the list of vehicles added on the Cluster Shipper Details screen.

**Edit Button:**

Clicking this button will open the “Edit Cluster Shipper” dialog.

**Cluster Conversion Company:**

A read-only label that displays the value selected in the “Add Cluster Shipper” dialog

**Exporter:**

A read-only label that displays the value selected in the “Add Cluster Shipper” dialog

**Buyer:**

A read-only label that displays the value selected in “Add Cluster Shipper” dialog

**Drop off Date:**

A read-only field that displays the date the “3rd Party Conversion Delivery” photo was uploaded to the Cluster Shipper.

**Cluster Conversions Completed:**

A read-only field that displays the completion status of cluster conversions associated with the shipper:

If all clusters associated with the shipper have been scanned back in (“Cluster Conversion Completed”), this field shows the date the last cluster was scanned back in at BWI.

If any clusters associated with the shipper have not been scanned back in, this field displays a “-”.`}
              </GreenText>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </>
  )
}
